<template>
  <div class="view cookies">
    <div class="content">
      <h1>Charte sur la gestion des cookies</h1>
      <div class="container">
        <p>Le Conseil national est susceptible de mettre en oeuvre des traceurs, communément appelés cookies, sur son site.</p>
      </div>
      <h2>Qu'est-ce qu'un cookie ?</h2>
      <div class="container">
        <p>Un cookie est un petit fichier texte sauvegardé sur l’ordinateur ou le téléphone mobile du Visiteur ou de l’Utilisateur qui consulte le Site. Il contient plusieurs données :</p>
        <ul>
          <li>Le nom du serveur qui l'a déposé ;</li>
          <li>Un identifiant sous forme de numéro unique ;</li>
          <li>Éventuellement une date d'expiration.</li>
        </ul>
      </div>

      <h2>A quoi servent les cookies émis sur notre site ?</h2>
      <div class="container">
        <p>Les cookies utilisés sur le site permettent :</p>
        <ul>
          <li>D’accéder, par voie de transmission électronique, à des informations déjà stockées dans l'équipement (smartphone, tablettes, ordinateur, etc.) utilisé par le Visiteur ou l’Utilisateur lors de sa navigation sur le Site afin d'identifier les services et rubriques que l'Utilisateur et/ou le Visiteur a visité, et plus généralement son comportement en matière de visites. Ils mesurent le nombre de visites, le nombre de pages vues ainsi que son activité et sa fréquence de retour ;</li>
          <li>À inscrire des informations dans cet équipement (notamment, le fichier permettant à l’Utilisateur de rester connecté sur son Compte) ;</li>
        </ul>
        <p>Ces informations sont utiles pour faciliter la navigation sur le Site et l'adapter à ses besoins. Des cookies sont également nécessaires au bon fonctionnement de certains services, notamment en matière de protocole de sécurisation de sa visite.</p>
      </div>

      <h2>Quels types de cookies sont utilisés sur notre site ?</h2>
      <div class="container">
        <p>Les Visiteurs et Utilisateurs sont informés que les cookies déposés et/ou lus sur leur équipement peuvent être les suivants :</p>
        <ul>
          <li>Les cookies dits « essentiels » ou « nécessaires »</li>
        </ul>
        <p>Ces cookies permettent de naviguer sur le Site et sont indispensables au bon fonctionnement du Site. Leur désactivation entraînera des difficultés dans l’utilisation du Site et aura pour conséquence d'empêcher l'accès à certaines fonctionnalités.</p>
        <p>Ces cookies servent notamment à adapter la présentation du site à vos préférences d’affichage du terminal (langue utilisée, résolution d’affichage, système d’exploitation utilisé, etc…), à mémoriser des informations relatives à vos identifiants ou encore à mettre en œuvre des mesures de sécurité, par exemple lorsqu’il vous est demandé de vous connecter à nouveau à un contenu ou à un service après une certaine durée écoulée. Ces cookies sont gérés par votre navigateur. Le Conseil national n'opère pas ce type de cookies.</p>
      </div>

      <h2>Comment sont mesurées la performance et la fréquentation sur notre site ?</h2>
      <div class="container">
        <p>La mesure de la performance et de la fréquentation du site consiste à recueillir des renseignements sur la manière dont le Visiteur et/ou l’Utilisateur utilise le Site. Elle permet notamment d’identifier les pages qu’il consulte le plus souvent et les messages d’erreur qui apparaissent et d'établir des statistiques et volume de fréquentation et d'utilisation des divers éléments composant le Site (rubriques et contenus visités, parcours) afin d'améliorer l'intérêt et l'ergonomie des pages et des services proposés sur le Site. Enfin, cette mesure permet d’identifier et de résoudre les problèmes inhérents au fonctionnement du Site et de l’améliorer.</p>
        <p>Cette mesure est effectuée par Piwik PRO, outil de mesure de performance et de fréquentation ne recourant pas à des cookies et n'impliquant pas de suivi via User ID. Par ailleurs, les données des utilisateurs sont anonymisées (adresse IP notamment).</p>
        <p>Ce suivi des utilisateurs est donc exempt de consentement.</p>
      </div>

      <h2>Comment exprimer vos choix par rapport à ces cookies ?</h2>
      <div class="container">
        <p>Les cookies utilisés par le Conseil national étant exempts de consentement, vous n'avez pas de choix à exprimer par rapport à ceux-ci.</p>
        <p>Néanmoins, vous pouvez toujours exercer vos droits par rapport au traitement de vos données à caractère personnel par le Conseil national en vous rendant sur la page "Charte RGPD" de notre site.</p>
      </div>

      <div class="container space-up">
        <p>Date de mise à jour : 25/05/2025</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CookiesComponent',
};
</script>

<style scoped lang="scss">
.view.cookies {
  padding: 64px 0 96px;

  h1 {
    color: $blue-color;
    font-family: $title-font;
    font-size: 48px;
    font-weight: bold;
    margin-bottom: 32px;
  }

  h2 {
    color: $darkblue-color;
    font-family: $title-font;
    font-size: 24px;
    font-weight: bold;
    margin: 24px 0 16px;
  }

  .container {
    color: #777;
    line-height: 24px;

    &.space-up {
      margin-top: 3rem;
    }

    p {
      margin: 2px 0 8px;
    }

    ul {
      li {
        padding-left: 8px;

        &::before {
          content: '-';
          margin-right: 4px;
        }
      }
    }
  }

  .cookies-container {
    margin: 24px 0;

    .line {
      color: $darkblue-color;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 4px 0;
      padding: 16px 24px;
      background: #f4f5f6;

      .description-container {
        padding-right: 24px;

        .name {
          font-weight: 700;
          margin: 0 0 8px;
        }
      }

      .checkbox-container {
        display: flex;
        flex-shrink: 0;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 64px;
        margin-top: 4px;
        cursor: pointer;

        .checkbox {
          position: relative;
          flex-shrink: 0;
          width: 64px;
          height: 32px;
          background: $lightgrey-color;
          border-radius: 2px;
          outline: solid 2px transparent;
          transition: 0.3s ease-in-out;

          &::after {
            content: '';
            position: absolute;
            top: 2px;
            left: 2px;
            bottom: 2px;
            width: 28px;
            border: solid 2px $darkblue-color;
            background: transparent;
            border-radius: 2px;
            box-sizing: border-box;
            transition: 0.3s ease-out;
          }
        }

        .checkbox-label {
          font-size: 12px;
          margin-top: 4px;
        }

        &.forced {
          opacity: 0.8;
          filter: grayscale(1);
          cursor: not-allowed;
        }

        &.active {
          .checkbox {
            &::after {
              left: calc(50% + 2px);
              background: $darkblue-color;
            }
          }

          .checkbox-label {
            font-weight: 700;
          }
        }

        &:hover:not(.forced) {
          .checkbox {
            outline: solid 2px $focus-color;
          }
        }

        &:active:not(.forced) {
          .checkbox {
            outline: solid 2px transparent;

            &::after {
              transform: scale(0.9);
            }
          }
        }

        &:focus-visible:not(.forced) {
          .checkbox {
            outline: solid 2px $focus-color;
          }
        }
      }
    }
  }

  table {
    margin: 16px 0 24px;
    border-right: solid 2px #f4f5f6;
    border-left: solid 2px #f4f5f6;

    thead {
      font-weight: 700;
      background: #f4f5f6;
    }

    tr {
      td {
        padding: 12px;
        vertical-align: middle;
        line-height: 24px;
        border-bottom: solid 2px #f4f5f6;

        strong {
          font-weight: bold;
        }
      }
    }
  }
}
</style>
